module.exports = __webpack_public_path__ + "img/quit_icon.d639e846.svg";